import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CloseIcon } from '@gem/icons';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { customScrollStyles, IconButton } from '@gem/ui-kit';

import { WorkspaceProfile } from 'APP/main/Profile/WorkspaceProfile/WorkspaceProfile';

import styles from './WorkspaceProfilePopup.styles.m.css';

export const WorkspaceProfilePopup: FC<ICommonPopupsProps> = observer(({ popupInstance }) => {
  useClosePopupOnNavigation(popupInstance);

  return (
    <Popup
      isOpened
      isHidden={popupInstance.isHidden}
      onClose={popupInstance.close}
    >
      <div className={classNames(styles.scrollContainer, customScrollStyles.container)}>
        <IconButton
          Icon={CloseIcon}
          className={styles.close}
          data-test="close-popup"
          onClick={popupInstance.close}
        />
        <WorkspaceProfile
          metaBlockClassName={styles.profileMetaBlock}
          popupInstance={popupInstance}
        />
      </div>
    </Popup>
  );
});
